module.exports = __webpack_public_path__ + "img/trash_can@2x.0cfbf409.png";